
import { api_host,api_auth} from '../../common/globals/constants';

export const getDataMaintenance = (client, token, date, user, objectives, method) => 

fetch(api_host+`/reporte/online/indicadores/getDataMaintenance/?clientId=${client}&token=${token}&fecha=${date}&user=${user}&method=${method}&objectives=${objectives}&_ts=${Date.now()}`)
.then(response => response.json())
